import { useEffect } from 'react';

/**
 * Hook para bloquear o scroll do body quando um modal estiver aberto
 * @param isLocked - Boolean que indica se o scroll deve estar bloqueado
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      // Salvar a posição atual do scroll
      const scrollY = window.scrollY;
      
      // Bloquear scroll
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      return () => {
        // Restaurar scroll quando modal fechar
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [isLocked]);
};

/**
 * Hook para gerenciar modais com bloqueio de scroll e fechamento por ESC
 * @param isOpen - Boolean que indica se o modal está aberto
 * @param onClose - Função para fechar o modal
 */
export const useModal = (isOpen: boolean, onClose: () => void) => {
  // Bloquear scroll quando modal estiver aberto
  useScrollLock(isOpen);

  useEffect(() => {
    if (isOpen) {
      // Função para fechar modal com ESC
      const handleEscKey = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };

      // Adicionar listener para ESC
      document.addEventListener('keydown', handleEscKey);
      
      return () => {
        // Remover listener
        document.removeEventListener('keydown', handleEscKey);
      };
    }
  }, [isOpen, onClose]);
};
